import { render, staticRenderFns } from "./BaseMobileFooter.vue?vue&type=template&id=6bfc00b8&scoped=true"
import script from "./BaseMobileFooter.vue?vue&type=script&lang=ts"
export * from "./BaseMobileFooter.vue?vue&type=script&lang=ts"
import style0 from "./BaseMobileFooter.vue?vue&type=style&index=0&id=6bfc00b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfc00b8",
  null
  
)

export default component.exports